export const PROJECT_SPEAKER_SETUP_ACTIVATE = 'PROJECT_SPEAKER_SETUP_ACTIVATE';
export const PROJECT_SPEAKER_SETUP_DEACTIVATE = 'PROJECT_SPEAKER_SETUP_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/actions/speaker-setup.ts